import { FC } from "react";
import { AllieIconButtonProps } from "./IconButton.types";
import { StyledIconButton } from "./IconButton.styles";

export const AllieIconButton: FC<AllieIconButtonProps> = ({
  type = 'primary',
  corner = 'rounded',
  shadow = false,
  loading = false,
  disabled = false,
  size = 'normal',
  allieColor = 'primary',
  iconOnly,
  icon,
  ...props
}) => (
  <StyledIconButton
    allieType={type}
    corner={corner}
    shadow={shadow}
    loading={loading}
    disabled={disabled}
    allieSize={size}
    allieColor={allieColor}
    icon={icon}
    iconOnly={iconOnly}
    {...props}
  />
);
